import React from 'react';

import { Link } from 'react-router-dom';

import { Container } from './styleMenu';

function ModulosMenu() {
  return (
    <Container>
      <Link to="/modulo/register" className="link">
        Cadastrar módulo
      </Link>
      <Link to="/modulo/list" className="link">
        Listar módulos
      </Link>
      <Link to="/modulo/empresa" className="link">
        Módulo empresa
      </Link>
    </Container>
  );
}

export default ModulosMenu;
